import(/* webpackMode: "eager" */ "/vercel/path0/app/campaigns/[id]/error.js");
